import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect, Provider } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as _ from '../lodash';
import rentalPage from '../page/RentalPage';
import store from '../configureStore';
import { getTimeFrameFromDate } from '../utilities/timeUtility';
import * as productActions from '../actions/products';
import * as frameActions from '../actions/frames';
import * as orderActions from '../actions/orders';
import * as settingActions from '../actions/settings';
import * as cartActions from '../actions/cart';

const mapStateToProps = ({
  settings,
  product,
  order,
  frames: {
    frames,
    blackouts,
    availableBlocks,
    nonAvailableBlocks,
    isFetchingBlocks,
    ...framesProps
  },
}) => ({
  order,
  frames,
  blackouts,
  ...settings,
  ...framesProps,
  availableBlocks,
  isFetchingBlocks,
  nonAvailableBlocks,
  isDemo: window.bta.isDemo,
  product_id: product.data.id,
  timeZone: window.bta.timeZone,
  minDate: product.data.mindate,
  maxDate: product.data.maxdate,
  options: product.data.options,
  variants: product.data.variants,
  schedule: product.data.schedule,
  capacity: product.data.capacities,
  durations: product.data.durations,
  rangeCountBasis: product.data.range_count_basis,
  // Parse lead_time from string to Number.
  leadTime: +product.data.lead_time,
  productOptions: product.data.options,
  // Convert lag_time from minutes to days.
  lagTime: product.data.lag_time / 1440,
  external_id: product.data.external_id,
  locale: window.bta.locale.substr(0, 2),
  maxAvailability: product.maxAvailability,
  locations: product.data.locations,
  resources: product.data.resources,
});

const mapDispatchToProps = dispatch => ({
  frameActions: bindActionCreators({ ...frameActions }, dispatch),
  orderActions: bindActionCreators({ ...orderActions }, dispatch),
  cartActions: bindActionCreators({ ...cartActions }, dispatch),
});

const RentalPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(rentalPage);

export default class RentalWidgetContainer extends Component {
  UNSAFE_componentWillMount() {
    let { settings } = this.props;
    const { product, defaultTranslation } = this.props;
    const newStyle = window.xprops.data && window.xprops.data.style;
    if (newStyle) {
      settings = _.deepMerge(settings, { style: newStyle });
    }

    store.dispatch(
      settingActions.setConfiguration({
        ...settings,
        defaultTranslation,
      }),
    );

    // here get data from api originally, later change to get from rails
    store.dispatch(productActions.fetchProduct(product)).then(() => {
      if (window.xchild && window.xchild.onProps) {
        window.xchild.onProps(({ data }) => {
          if (data && data.id) {
            const { id, quantity } = data;
            store.dispatch(orderActions.setVariantsQuantity(`${id}_quantity`, quantity));
          }
        });
      }
    });
  }

  componentDidMount() {
    if (window.xprops && window.xprops.onInit) {
      window.xprops.onInit(this.props.settings.setting);
    }
  }

  render() {
    return (
      <div>
        <Provider store={store}>
          <RentalPage />
        </Provider>
      </div>
    );
  }
}

window.changeStyle = value => store.dispatch(settingActions.setStyle(value));
window.changeTranslation = (key, value) => {
  store.dispatch(settingActions.setTranslation(key, value));
};

RentalWidgetContainer.propTypes = {
  defaultTranslation: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
};
